export const FILTER_LIST_ITEM_COUNT = 'FILTER_LIST__ITEM_COUNT';

export const FILTER_CONTROLS_RESET_BUTTON = 'FILTER_CONTROLS__RESET_BUTTON';
export const FILTER_CONTROLS_VIEW_RESULTS_BUTTON = 'FILTER_CONTROLS__VIEW_RESULTS_BUTTON';
